import { render, staticRenderFns } from "./CollectionPrEcPage.vue?vue&type=template&id=27376fa8"
import script from "./CollectionPrEcPage.vue?vue&type=script&lang=js"
export * from "./CollectionPrEcPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports